import { Channel } from 'redux-saga';
import { SendCommand } from './Socket/Commands';
import { take } from 'redux-saga/effects';
import { put } from 'typed-redux-saga';

export function* commandRouterSaga(
  globalChannel: Channel<SendCommand>,
  chatChannel: Channel<SendCommand>,
  statusChannel: Channel<SendCommand>,
) {
  while (true) {
    const action: SendCommand = yield take(globalChannel);

    switch (action.nameSpace) {
      case '/status':
        yield put(statusChannel, action);
        break;
      case '/chat':
      default:
        yield put(chatChannel, action);
        break;
    }
  }
}
